import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

type CustomDropdownProps = {
  options: number[];
  casesNumber: number;
  currentValue: number;
  onChange: (value: number) => void;
};

const CustomDropdown = ({
  options,
  casesNumber,
  currentValue,
  onChange
}: CustomDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary">
          {currentValue}
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-auto min-w-20">
        {options.map((pageSize) => (
          <DropdownMenuItem
            key={pageSize}
            onSelect={() => onChange(pageSize)}
            disabled={pageSize > casesNumber}
            className={cn(
              "justify-center px-6",
              currentValue === pageSize && "bg-fill-3 font-medium"
            )}
          >
            {pageSize}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CustomDropdown;
